import React, { useEffect, useState } from "react";
import { useCustomerContext } from "contexts/Customer";
import { IAdvanceSearch } from "types";
import "./style.scss";

type Props = {
	index: number;
	oprList?: string[];
	isAllowed: boolean;
};

export const AdvanceSelect: React.FC<Props> = ({
	index,
	oprList,
	isAllowed,
}) => {
	const { searchFields, updateSearchFields } = useCustomerContext();
	const [prevIndex, setPrevIndex] = useState<number>(0);
	const [type, setType] = useState<string>(searchFields[index].searchType);
	const [fieldList, setFieldList] = useState<IAdvanceSearch[]>(searchFields);

	const handleClick = (e: any) => {
		const selectedName = e.target.value;
		fieldList.forEach((item, position) => {
			if (item.name == selectedName) {
				setPrevIndex(position);
			}
		})
	}

	const handleChange = (e: any) => {
		const selectedName = e.target.value;
		const selectedIndex = e.target.selectedIndex;
		let tempList = [...fieldList];
		if (!oprList) {		// name
			tempList.forEach((item) => {
				if (item.name == selectedName && !item.isSelected) {		// update current clicked item's isSelected
					tempList[prevIndex].order = item.order;
					item.order = index;
					item.isSelected = true;
					item.searchType = tempList[prevIndex].searchType;
					item.value = tempList[prevIndex].value;
					tempList[prevIndex].isSelected = false;
					tempList[prevIndex].value = "";
				}
			})
		}
		else {		// searchType
			setType(selectedName);
			tempList.forEach((item) => {
				if (item.order == index) {
					item.searchType = selectedName;
				}
			})
		}
		tempList.sort((a, b) => (a.order > b.order) ? 1 : -1);
		console.log(tempList);
		setFieldList(tempList);
		updateSearchFields(tempList);
	};

	return (
		<div className="advance-select">
			<select
				value={!oprList ? fieldList[index].name : type}
				onClick={(e: any) => { if (oprList == undefined) handleClick(e); }}
				onChange={handleChange}
				disabled={!isAllowed}
			>
				{oprList == undefined && searchFields.filter((item) => item.isAvailable === true).map((item, index) => (
					<option key={index}>{item.name}</option>
				))}
				{oprList != undefined && oprList.map((item, index) => (
					<option key={index}>{item}</option>
				))}
			</select>
		</div>
	);
};
